<tilby-dialog-toolbar title="HISTORY.SUMMARY_INVOICE_DIALOG.TITLE" [hideConfirm]="true">
    <div class="tw-flex tw-items-center tw-justify-evenly tw-w-3/4" toolbar-content>
        <mat-form-field>
            <mat-label>{{"HISTORY.SUMMARY_INVOICE_DIALOG.FROM_TO" | translate}}</mat-label>
            <mat-date-range-input [formGroup]="range" [rangePicker]="picker">
                <input matStartDate formControlName="closed_at_since" #dateRangeStart>
                <input matEndDate formControlName="closed_at_max" #dateRangeEnd (dateChange)="addEvent()">
            </mat-date-range-input>
            <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-date-range-picker #picker (closed)="onClose()"></mat-date-range-picker>
        </mat-form-field>
        @if (range.controls.closed_at_since.hasError('matStartDateInvalid')) {
            <mat-error class="tw-text-[0.9rem]">{{"HISTORY.SUMMARY_INVOICE_DIALOG.MANDATORY_START_DATE" | translate}}</mat-error>
        }
        @if (range.controls.closed_at_max.hasError('matEndDateInvalid')) {
            <mat-error class="tw-text-[0.9rem]">{{"HISTORY.SUMMARY_INVOICE_DIALOG.MANDATORY_END_DATE" | translate}}</mat-error>
        }
        @if (range.controls.closed_at_max.hasError('matEndYearInvalid')) {
            <mat-error class="tw-text-[0.9rem]">{{"HISTORY.SUMMARY_INVOICE_DIALOG.INVALID_END_YEAR" | translate}}</mat-error>
        }
        <mat-form-field>
            <mat-label>{{"HISTORY.SUMMARY_INVOICE_DIALOG.TYPE_INVOICE" | translate}}</mat-label>
            <mat-select [(ngModel)]="selectedType" (selectionChange)="changeType($event)">
                <mat-option>{{"HISTORY.SUMMARY_INVOICE_DIALOG.ALL" | translate}}</mat-option>
                <mat-option value="collected">{{'HISTORY.SUMMARY_INVOICE_DIALOG.COLLECTED' | translate}}</mat-option>
                <mat-option value="not_collected">{{'HISTORY.SUMMARY_INVOICE_DIALOG.NOT_COLLECTED' | translate}}</mat-option>
            </mat-select>
        </mat-form-field>
    </div>
</tilby-dialog-toolbar>
<tilby-dialog-content>
    <section class="tw-max-h-80 tw-min-h-80 tw-overflow-auto" tabindex="0">
        @if(!isLoading){
            <table mat-table [dataSource]="filteredDataSource">
                <ng-container matColumnDef="name">
                    <th mat-header-cell *matHeaderCellDef translate="HISTORY.SUMMARY_INVOICE_DIALOG.NAME"></th>
                    <td mat-cell *matCellDef="let element">{{element.company_name}} {{element.first_name}} {{element.last_name}}</td>
                </ng-container>
                <ng-container matColumnDef="invoice_type">
                    <th mat-header-cell *matHeaderCellDef translate="HISTORY.SUMMARY_INVOICE_DIALOG.INVOICE_TYPE"></th>
                    <td mat-cell *matCellDef="let element">
                        {{element.collected ? ('HISTORY.SUMMARY_INVOICE_DIALOG.COLLECTED' | translate) : ('HISTORY.SUMMARY_INVOICE_DIALOG.NOT_COLLECTED' | translate) }}
                    </td>
                </ng-container>
                <ng-container matColumnDef="documents_to_be_invoiced">
                    <th mat-header-cell *matHeaderCellDef translate="HISTORY.SUMMARY_INVOICE_DIALOG.DOCUMENTS_TO_BE_INVOICED"></th>
                    <td mat-cell *matCellDef="let element">{{element.transaction_count}}</td>
                </ng-container>
                <ng-container matColumnDef="total_to_be_invoiced">
                    <th mat-header-cell *matHeaderCellDef translate="HISTORY.SUMMARY_INVOICE_DIALOG.TOTAL_TO_BE_INVOICED"></th>
                    <td mat-cell *matCellDef="let element">{{element.transaction_total | tilbyCurrency}}</td>
                </ng-container>
                <ng-container matColumnDef="details" stickyEnd>
                    <th mat-header-cell *matHeaderCellDef translate="HISTORY.SUMMARY_INVOICE_DIALOG.DETAILS"></th>
                    <td mat-cell *matCellDef="let element">
                        <button mat-icon-button (click)="showDetails(element)">
                            <mat-icon class="material-symbols-outlined">document_search</mat-icon>
                        </button>
                    </td>
                </ng-container>
                <ng-container matColumnDef="star" stickyEnd>
                    <th mat-header-cell *matHeaderCellDef aria-label="row actions">&nbsp;</th>
                    <td mat-cell *matCellDef="let element">
                        <button mat-icon-button (click)="confirm(element)">
                            <mat-icon>list</mat-icon>
                        </button>
                    </td>
                </ng-container>
                    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                    @if (!isLoading && filteredDataSource) {
                        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                    }
            </table>
        }
        @if(!isLoading && filteredDataSource.length === 0){
            <div class="tw-text-center">
                <p translate="HISTORY.SUMMARY_INVOICE_DIALOG.NO_TRANSACTIONS_TO_BE_INVOICED"></p>
            </div>
        }
        @if(isLoading){
            <div class="tw-h-[250px] tw-text-center tw-flex-1">
                <mat-spinner class="primary tw-top-[90px] tw-left-[280px]" diameter="60"></mat-spinner>
            </div>
        }
    </section>
</tilby-dialog-content>
